/* Carte — design system : fond card + léger glass */

const Card = {
  baseStyle: {
    p: "22px",
    display: "flex",
    flexDirection: "column",
    backdropFilter: "blur(120px)",
    width: "100%",
    borderRadius: "20px",
    bg: "linear-gradient(127.09deg, rgba(13, 13, 13, 0.95) 19.41%, rgba(13, 13, 13, 0.6) 76.65%)",
    border: "none",
    backgroundClip: "border-box",
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
